export enum MiddlewareInjectToken {
    Config = 'Config',
    Cache = 'Cache',
    OrbisApi = 'OrbisApi',
    MiddlewareApi = 'MiddlewareApi',
    InsightApi = 'InsightApi',
    BridgeWiseApi = 'BridgeWiseApi',
    UmaApi = '  UmaApi',
    AesMidasApi = 'AesMidasApi',
    Apis = 'Apis',
}

export enum ApiInjectToken {
    BranchApi = 'BranchApi',
    ModelApi = 'ModelApi',
    GroupApi = 'GroupApi',
    UserApi = 'UserApi',
    AccountApi = 'AccountApi',
    MarketApi = 'MarketApi',
    TradingApi = 'TradingApi',
    QuoteApi = 'QuoteApi',
    WatchlistApi = 'WatchlistApi',
    ResearchApi = 'ResearchApi',
    StatApi = 'StatApi',
    NewsApi = 'NewsApi',
    TipranksApi = 'TipRanksApi',
    WebSocketApi = 'WebSocketApi',
    DocumentApi = 'DocumentApi',
    OnboardingApi = 'OnboardingApi',
}
